
/**
* Aggancia l'autocomplete di Google all'indirizzo di fatturazione della pagina Modifica profilo.
* Il callback dello script di Google può arrivare prima che DevExtreme abbia renderizzato il TextBox:
* initAutocomplete è idempotente, quindi si richiama anche qui.
* Claude
*/
function EP_InitAutocomplete() {
    if ($('#feditprofilo').length > 0 && typeof initAutocomplete === 'function') {
        setTimeout(() => {
            initAutocomplete();
        }, 300);
    }
}

// questo file è caricato su tutte le pagine (JSPartial): agisce solo in Modifica profilo
$(document).ready(EP_InitAutocomplete);

// dopo il cambio di tipologia il form viene ricaricato via AJAX: riaggancia l'autocomplete ai nuovi campi
$(document).ajaxComplete(function (event, xhr, settings) {
    if (settings && settings.url && settings.url.indexOf('RefreshFormModificaProfiloUtente') >= 0) {
        EP_InitAutocomplete();
    }
});

/*
* Pagina Account/EditProfilo (view Common) con campi DevExtreme.
* Sostituisce UpdateUser di common.js per questa pagina: UpdateUser resta per gli override
* Tipo18/Tipo36 che usano ancora input Bootstrap.
* Claude
*/

/**
* Restituisce l'istanza del widget DevExtreme renderizzato nel contenitore con l'id indicato.
* Claude
* @param {string} id - id del contenitore del widget
* @returns {object} istanza del widget o null
*/
function EP_Istanza(id) {
    var el = document.getElementById(id);
    if (!el || typeof DevExpress === 'undefined') {
        return null;
    }

    var tipi = ['dxTextBox', 'dxSelectBox', 'dxDateBox', 'dxLookup'];
    for (var i = 0; i < tipi.length; i++) {
        var widget = DevExpress.ui[tipi[i]];
        var istanza = widget ? widget.getInstance(el) : null;
        if (istanza) {
            return istanza;
        }
    }
    return null;
}

/**
* Espone un widget DevExtreme con l'interfaccia jQuery (val, addClass, removeClass) usata da
* CheckCapReg e CheckSdi, così da riusarle senza modifiche.
* Claude
* @param {string} id - id del contenitore del widget
*/
function EP_Adattatore(id) {
    var istanza = EP_Istanza(id);
    return {
        length: istanza ? 1 : 0,
        val: function () {
            var valore = istanza ? istanza.option('value') : null;
            return valore == null ? '' : String(valore);
        },
        addClass: function () {
            if (istanza) {
                istanza.option('isValid', false);
            }
            return this;
        },
        removeClass: function () {
            if (istanza) {
                istanza.option('isValid', true);
            }
            return this;
        }
    };
}

/**
* Ricarica il contenuto del form quando l'utente cambia la tipologia di profilo.
* Claude
* @param {any} e - evento valueChanged della SelectBox
*/
function EP_TipoUtenteCambiato(e) {
    if (e.value == null || e.value === e.previousValue) {
        return;
    }
    UpdateEditProfiloForm(EP_modelloProfilo, e.value);
}

/**
* Lascia solo le cifre nei campi telefono/cellulare e, appena uno dei due è valorizzato,
* toglie l'errore di recapito mancante.
* Claude
* @param {any} e - evento valueChanged della TextBox
*/
function EP_SoloNumeri(e) {
    var valore = e.value || '';
    var pulito = valore.replace(/\D/g, '');
    if (pulito !== valore) {
        e.component.option('value', pulito);
        return;
    }

    if (pulito.length > 0) {
        EP_Adattatore('reg-ftelefono').removeClass();
        EP_Adattatore('reg-fcellulare').removeClass();
        $('#chkfrecapito').html('');
    }
}

/**
* Porta in vista il primo campo non valido del form.
* Claude
*/
function EP_ScrollPrimoErrore() {
    var primo = $('#feditprofilo .dx-invalid, #feditprofilo .is-invalid').first();
    if (primo.length > 0) {
        $('html, body').animate({ scrollTop: Math.max(primo.offset().top - 140, 0) }, 300);
    }
    else {
        $(window).scrollTop(0);
    }
}

/**
* Effettua la validazione del form di modifica profilo prima del submit.
* Claude
* @param {number} lcid
* @param {number} idIndirizzo - id dell'indirizzo di fatturazione (suffisso degli id provincia/città)
* @returns {boolean} true se il form può essere inviato
*/
function ValidaModificaProfilo(lcid, idIndirizzo) {
    waitingBS.Show();

    try {
        var formstate = true;
        var tipologia = EP_Istanza('reg-tipologiaprofiloutente');
        var usertype = parseInt(tipologia ? tipologia.option('value') : 0);

        /* Campi obbligatori dei widget DevExtreme (ValidationRules nella view) */
        $('#feditprofilo .dx-validator').each(function () {
            var validatore = $(this).dxValidator('instance');
            if (validatore && validatore.validate().isValid == false) {
                formstate = false;
            }
        });

        /* Campi obbligatori HTML rimasti nei componenti condivisi (es. provincia/città testuali) */
        $('#feditprofilo :input[required]').each(function () {
            if ($(this).closest('.dx-widget').length > 0 || this.disabled) {
                return;
            }
            if (!$(this).val() || $(this).val().trim() == '') {
                $(this).addClass('is-invalid');
                formstate = false;
            }
            else {
                $(this).removeClass('is-invalid');
            }
        });

        /* Fatturazione Elettronica */
        var pFattEle = $('#panel-fattele');
        if (pFattEle.length > 0) {
            var pec = EP_Adattatore('reg-fpec');
            var sdi = EP_Adattatore('reg-fsdi');
            pec.removeClass();
            sdi.removeClass();
            $('#msgpec').html('');
            $('#msgsdi').html('');

            if (pFattEle.attr('required') && !sdi.val() && !pec.val()) {
                sdi.addClass();
                pec.addClass();
                $('#msgsdi').html(mainController.GetLabel('lErroreFattElettronica'));
                formstate = false;
            }
            else {
                if (sdi.val() && CheckSdi(sdi, usertype) == false) {
                    formstate = false;
                }
                if (pec.val() && mainController.CheckEmail(pec.val()) == false) {
                    pec.addClass();
                    $('#msgpec').html(mainController.GetLabel('lErrorePEC'));
                    formstate = false;
                }
            }
        }

        /* Controllo provincia e città */
        if (CheckCittaEProvincia(lcid, idIndirizzo) == false) {
            formstate = false;
        }

        /* Controllo del CAP (il vuoto è già segnalato dal validatore required) */
        var cap = EP_Adattatore('reg-fcap');
        if (cap.val() && CheckCapReg(cap, lcid, $('#errorefcap')) == false) {
            formstate = false;
        }

        /* Recapito telefonico: almeno uno tra telefono e cellulare, con prefisso */
        var ftel = EP_Adattatore('reg-ftelefono');
        var fcel = EP_Adattatore('reg-fcellulare');

        if (ftel.val().trim() === '' && fcel.val().trim() === '') {
            ftel.addClass();
            fcel.addClass();
            $('#chkfrecapito').html(mainController.GetLabel('lAvvisoRecapito'));
            formstate = false;
        }
        else {
            ftel.removeClass();
            fcel.removeClass();
            $('#chkfrecapito').html('');

            if (ftel.val().trim().length > 0) {
                if (CheckPrefisso('select_prefisso_tel_fatt') != true) {
                    formstate = false;
                }
            }
            else if (CheckPrefisso('select_prefisso_cell_fatt') != true) {
                formstate = false;
            }
        }

        if (formstate == true) {
            if ($('#listspecialita').length > 0) {
                var specialita = $('#listspecialita').dxList('instance')?.option('selectedItemKeys');
                if (specialita && specialita.length == 0) {
                    waitingBS.Hide();
                    mainController.NotifyMessage(mainController.GetLabel('lErroreSpecialitaScelta'), 'error');
                    return false;
                }
            }
            return true;
        }

        waitingBS.Hide();
        EP_ScrollPrimoErrore();
        return false;
    }
    catch (e) {
        console.log(e);
        waitingBS.Hide();
        EP_ScrollPrimoErrore();
        return false;
    }
}
